import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useState } from 'react';
import s from './index.less';
import Link from '../../../components/Link';
import Nothing from "../../../components/nothing";
import Pagination from 'rc-pagination';
import pageS from '../../list/assets/pagination.less';
import qs from 'qs';


export default function DecorationProcurement (props) {
    useStyles(s);
    useStyles(pageS);
    
    const pageData = props.pageData || {};
    const [param, setParam] = useState(pageData.params);
    const goPage = (link) => {
        window.open('_self').location = link;
    }
    const pageChange = (page, pageSize) => {
        setParam(Object.assign(param,{page,size: pageSize}))
        document.body.scrollIntoView({ behavior: 'smooth' })
        getDataList()
    };
    const getDataList = async () => {
        const newParam = { ...param };
        window.location.href = `/elderlyRenovation/list?${qs.stringify(newParam)}`;
    };
    return (
        <div className="page-home">
            <div className='container'>
                <div className="bread-box">
                    <Link to="/" target="_blank">首页</Link><span>&#65125;</span>
                    <Link to="/elderlyRenovation" target="_blank">适老改造</Link><span>&#65125;</span>优秀改造案例
                </div>
                <div className="main-box">
                    {
                        pageData.total ?
                            <ul className="list-box">
                                {
                                    pageData.list.map((item, index) => {
                                        return (
                                            <li key={index} onClick={()=>{goPage(`/generalPage?id=${item.id}&type=2`)}}>
                                                <div className="img-box">
                                                    <img src={item.imgUrl ? `${item.imgUrl}?x-oss-process=style/asmall` : require("../../../images/common/detail-default.png")} alt="" />
                                                </div>
                                                <div className="info-box">{ item.title }</div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                            : <Nothing />
                    }
                    {pageData.total ?
                        <div className='pagination-box'>
                            <Pagination prevIcon="上一页" nextIcon="下一页" current={param.page - 0} pageSize={param.size - 0} total={pageData.total - 0} onChange={pageChange} />
                        </div> : null
                    }
                </div>
            </div>
        </div>
    );
}